import ApiClient from "@/api/ApiClient";
import {
  MultimediaPurchaseHistoryListResponse,
  MultimediaPurchaseHistoryResponse,
} from "@API/src/component/memoruHome/purchaseHistory/types";
import {
  FetchPurchaseHistoryListRequest,
  FetchPurchaseHistoryRequest,
  CancelPurchaseHistoryRequest,
} from "@/model/request/purchaseHistory";
import {
  isTypeMultimediaPurchaseHistoryListResponse,
  isTypeMultimediaPurchaseHistoryResponse,
} from "@/model/typeGuard/purchaseHistory";
import { isTypeMultimediaCartItemListResponse, isTypeMultimediaCartItemResponse } from '../model/typeGuard/cart';
import { MultimediaCartItemListResponse, MultimediaCartItemResponse } from "chaild-entity/src/component/memoruHome/cart/types";

export default class ApiPurchaseHistory {
  public static async fetchPurchaseHistoryList(
    request: FetchPurchaseHistoryListRequest
  ): Promise<MultimediaPurchaseHistoryListResponse> {
    const response = await ApiClient.get(`/purchase-history`, request);
    if (isTypeMultimediaPurchaseHistoryListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchPurchaseHistory(
    request: FetchPurchaseHistoryRequest
  ): Promise<MultimediaCartItemListResponse> {
    const response = await ApiClient.get(`/purchase-history/${request.cartId}`, request);
    // console.log('response', response)
    if (isTypeMultimediaCartItemListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async cancelPurchaseHistory(
    request: CancelPurchaseHistoryRequest
  ): Promise<MultimediaPurchaseHistoryResponse> {
    const response = await ApiClient.post(
      `/purchase-history/${request.cartId}`,
      request
    );
    if (isTypeMultimediaPurchaseHistoryResponse(response)) {
      return response;
    }
    throw response;
  }
}
